__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/a86b1b4/packs/";